import axios from 'axios';

import Config from '@shared/config/constants/config-main';
import { setAlert } from '@shared/store/slices/alert.actions';
import { Helpers } from '@shared/utils/Helpers';

import * as VoucherActions from '@entities/voucher/store/voucher.actions';

const API_URL = Config.API_URL;

export const redeemVoucher = async (formData, history, isInternalDebugging = false) => {
  const config = Helpers.getAxiosHeadersConfig();

  const subscribeRequestBody = {
    mobile: formData.phone,
    email: formData.email,
    countryCode: formData.countryCode,
    voucherCode: formData.voucherCode,
    language: formData.language,
    source: formData.source,
    urlReferrer: window.location.href,
    adUrlReferrer: document.referrer || '',
    isDebugging: isInternalDebugging ? 1 : 0,
  };

  VoucherActions.writeVoucherBtnLoading(true);

  try {
    const res = await axios.post(
      `${API_URL}/api/voucher/subscribe`,
      subscribeRequestBody,
      config
    );

    const { data, statusCode, message } = res.data;

    VoucherActions.writeVoucherSubscribeResult(data);

    if (statusCode !== 200) {
      await setAlert(message?.message || message, 'danger');
      VoucherActions.writeVoucherHandledFailure();
      return;
    }

    history.push('/voucher/pin');
  } catch (err) {
    console.log('redeemVoucherError', err);
    await setAlert('Error processing request. Please contact support', 'danger');
    VoucherActions.writeVoucherHandledFailure();
  }
};

export const verifyVoucherOTP = async (
  formData,
  voucherData,
  history,
  isInternalDebugging = false
) => {
  const config = Helpers.getAxiosHeadersConfig();

  const subscribeRequestBody = {
    subscriberId: voucherData.subscriberId,
    subscriptionVoucherId: voucherData.subscriptionVoucherId,
    otp: formData.otp,
    language: formData.language,
    isDebugging: isInternalDebugging ? 1 : 0,
  };

  VoucherActions.writeVoucherBtnLoading(true);

  try {
    const res = await axios.post(`${API_URL}/api/voucher/verify`, subscribeRequestBody, config);

    const { data, statusCode, message } = res.data;

    VoucherActions.writeVoucherSubscribeResult(data);

    if (statusCode !== 200) {
      if (message) {
        await setAlert(message?.message || message, 'danger');
      } else {
        await setAlert(
          formData.language === 'ar' ? 'رقم التعريف غير صالح' : 'Invalid PIN',
          'danger'
        );
      }
      VoucherActions.writeVoucherHandledFailure();
      return;
    }

    const activationURL = data.activationURL || '';
    const query = `?activationUrl=${activationURL}`;

    history.push({
      pathname: `/voucher/congrats`,
      state: {
        activationURL,
        billingDurationType: data.billingDurationType,
        billingDuration: data.billingDuration,
      },
      search: query,
    });
  } catch (err) {
    console.log('verifyVoucherOTPError', err);
    await setAlert('Error processing request. Please contact support', 'danger');
    VoucherActions.writeVoucherHandledFailure();
  }
};

export const resendVoucherOTP = async (formData, voucherData, isInternalDebugging = false) => {
  const config = Helpers.getAxiosHeadersConfig();

  const subscribeRequestBody = {
    subscriberId: voucherData.subscriberId,
    subscriptionVoucherId: voucherData.subscriptionVoucherId,
    language: formData.language,
    isDebugging: isInternalDebugging ? 1 : 0,
  };

  VoucherActions.writeVoucherResendTimerTick();

  try {
    const res = await axios.post(
      `${API_URL}/api/voucher/subscribe/resend`,
      subscribeRequestBody,
      config
    );

    const { statusCode, message } = res.data;

    if (statusCode !== 200) {
      await setAlert(message?.message || message, 'danger');
    }
  } catch (err) {
    console.log('resendVoucherOTPError', err);
    await setAlert('Error processing request. Please contact support', 'danger');
    VoucherActions.writeVoucherHandledFailure();
  }
};

export { resetVoucherTimer } from '@entities/voucher/store/voucher.actions';
